var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7075 14.2936L10.8883 9.47237C11.5882 8.49212 11.9981 7.30183 11.9981 6.0015C11.9981 2.69067 9.30855 0 5.99906 0C2.68958 0 0 2.69067 0 6.0015C0 9.31233 2.68958 12.003 5.99906 12.003C7.29886 12.003 8.48867 11.5929 9.46852 10.8927L14.2878 15.7139C14.4877 15.904 14.7377 16.004 14.9977 16.004C15.2576 16.004 15.5076 15.904 15.7075 15.7139C16.0975 15.3238 16.0975 14.6837 15.7075 14.2936ZM5.99906 10.0025C3.78941 10.0025 1.99969 8.21205 1.99969 6.0015C1.99969 3.79095 3.78941 2.0005 5.99906 2.0005C8.20872 2.0005 9.99844 3.79095 9.99844 6.0015C9.99844 8.21205 8.20872 10.0025 5.99906 10.0025Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.22b1ec3f151a149d494a3f3ccc7e72a4.svg";
export { ForwardRef as ReactComponent };